import { NEWS_CATEGORY } from "constants/phase";
import { createSelector } from "reselect";
import { selectEntityConfigDetailsByEntityId } from "store/entityConfig/selectors";

import { categoryEntityAdapter, categorySlice } from "./slice";

const selectCategoryState = (state) => state[categorySlice.name];

export const selectCategories = createSelector(selectCategoryState, (categoryState) =>
  categoryEntityAdapter.getSelectors().selectIds(categoryState),
);

export const selectCategoryCount = createSelector(selectCategories, (categories) => categories.length);

export const selectCategoryEntities = createSelector(selectCategoryState, (categoryState) =>
  categoryEntityAdapter.getSelectors().selectEntities(categoryState),
);

export const selectAllCategoryDetails = createSelector(selectCategoryState, (categoryState) =>
  categoryEntityAdapter.getSelectors().selectAll(categoryState),
);

export const selectAllRuleEngineCategories = createSelector(selectAllCategoryDetails, (categories) =>
  categories.filter((item) => item.enableRuleEngine),
);

export const selectAllAutoFlipCategories = createSelector(selectAllCategoryDetails, (categories) =>
  categories.filter((item) => item.autoFlip).map((item) => item.name),
);

export const selectCategoryDetailsById = createSelector(
  selectCategoryState,
  (_, props) => props.category,
  (categoryState, category) => categoryEntityAdapter.getSelectors().selectById(categoryState, category) || null,
);

export const selectCategoryDetailsByCategoryId = createSelector(
  selectCategoryEntities,
  (_, props) => props.categoryId,
  (entities, categoryId) => Object.values(entities).find((entity) => entity._id === categoryId) || null,
);

export const selectCategoryNameById = createSelector(
  selectCategoryDetailsById,
  (categoryDetails) => categoryDetails?.name || "",
);

export const selectCategoryDisplayNameById = createSelector(
  selectCategoryDetailsById,
  (categoryDetails) => categoryDetails?.displayName || "",
);

export const selectCategoryNameByCategoryId = createSelector(
  selectCategoryDetailsByCategoryId,
  (categoryDetails) => categoryDetails?.name || "",
);

export const selectCategoryDetailsByEntityConfigCategories = createSelector(
  selectEntityConfigDetailsByEntityId,
  selectAllCategoryDetails,
  (entityConfigDetails, categories) =>
    categories?.filter((category) => entityConfigDetails?.categories?.includes(category?._id)),
);

export const selectCategoryAITags = createSelector(
  (state, props) => props.category,
  selectCategoryDetailsById,
  (category, categoryDetails) => categoryDetails?.aiTags || [],
);

export const selectHasNewsCategoryEnabled = createSelector(selectCategories, (categories) =>
  categories.includes(NEWS_CATEGORY),
);

export const selectIsNewsCategoryOnly = createSelector(
  selectCategories,
  selectHasNewsCategoryEnabled,
  (categories, hasNewsCategoryEnabled) => categories.length === 1 && hasNewsCategoryEnabled,
);
